"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultOperationPermission = exports.getProjectHours = void 0;
var _ = require("lodash");
var validations_1 = require("./validations");
var getProjectHours = function (worklogs) {
    var initialProjectHours = {
        work: { hours: 0, approvedHours: 0 },
        travel: { hours: 0, approvedHours: 0 },
        special: { hours: 0, approvedHours: 0 },
    };
    return _.reduce(worklogs, function (projectHours, worklog) {
        if (worklog.projectType) {
            if ((0, validations_1.isTravel)(worklog.projectType)) {
                projectHours.travel.hours += worklog.hours;
                projectHours.travel.approvedHours += Number(worklog.approvedHours);
            }
            else {
                projectHours.work.hours += worklog.hours;
                projectHours.work.approvedHours += Number(worklog.approvedHours);
            }
        }
        if (worklog.specialType) {
            projectHours.special.hours += worklog.hours;
            projectHours.special.approvedHours += Number(worklog.approvedHours);
        }
        return projectHours;
    }, initialProjectHours);
};
exports.getProjectHours = getProjectHours;
var getDefaultOperationPermission = function () {
    return {
        UPDATE: false,
        APPROVE: false,
        CONTROL: false,
    };
};
exports.getDefaultOperationPermission = getDefaultOperationPermission;
